const formatMoney = (money) => `$${(money || 0).toFixed(2)}`;

export default formatMoney;
